import MicroModal from 'micromodal'

const modal = () => {
    const modals = document.querySelectorAll('[data-micromodal-trigger]')

    if (!modals.length) return

    MicroModal.init({
        awaitCloseAnimation: true,
        awaitOpenAnimation: true,
        disableScroll: true,
    })
}

export default modal
